import { useQueryAiSetting } from './useQueryAiSetting'

export function useAiGlobalEnabled() {
	const { data, isLoading } = useQueryAiSetting()
	return {
		aiEnabled: data?.aiEnabled ?? true,
		isLoading,
	}
}
